import { useContext } from 'react';
import FeedbackItem from './FeedbackItem';
import FeedbackContext from '../../context/FeedbackContext';

const FeedbackList = () => {
  const { feedback } = useContext(FeedbackContext);

  if (!feedback || feedback.length === 0) {
    return <p>No Feedback Yet</p>;
  }

  return (
    <div className='feedback-list'>
      {feedback.map((feedbackItem) => {
        return <FeedbackItem item={feedbackItem} key={feedbackItem.id} />;
      })}
    </div>
  );
};

export default FeedbackList;
